module.exports = __webpack_public_path__ + "static/media/DeleteIcon.2a05b255.svg";